
import { destroy, get, getOne, post, put } from "../apis/httpClient"

export const pagingCandidate=(params)=>get('/api/v1/candidate/paging',params)
export const detailCandidate=(query)=>getOne(`/api/v1/candidate/detail/${query}`)
export const deleteCandidate=(body)=>destroy(`/api/v1/candidate/delete`,body)
export const viewCandidate=(query)=>get(`/api/v1/recruitment/view/${query}`)
